<template>
  <div class="googlewrapper">
    <img width="80%" alt="powered by google" src="../../../assets/powered_by_google_on_white_hdpi.png">
  </div>
</template>

<script>
export default {
  name: 'PoweredByGoogleWidget',

  methods: {
    requestData() {},
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.googlewrapper {
  background-color: white;
  color: black;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

</style>
